// ////////////////////////////スマホ/タブレット判別
var _ua = (function (u) {
  return {
    Tablet: (u.indexOf('windows') != -1 && u.indexOf('touch') != -1)
      || u.indexOf('ipad') != -1
      || (u.indexOf('android') != -1 && u.indexOf('mobile') == -1)
      || (u.indexOf('firefox') != -1 && u.indexOf('tablet') != -1)
      || u.indexOf('kindle') != -1
      || u.indexOf('silk') != -1
      || u.indexOf('playbook') != -1,
    Mobile: (u.indexOf('windows') != -1 && u.indexOf('phone') != -1)
      || u.indexOf('iphone') != -1
      || u.indexOf('ipod') != -1
      || (u.indexOf('android') != -1 && u.indexOf('mobile') != -1)
      || (u.indexOf('firefox') != -1 && u.indexOf('mobile') != -1)
      || u.indexOf('blackberry') != -1
  };
})(window.navigator.userAgent.toLowerCase());
// if(_ua.Mobile){}

var osVer;
osVer = 'Android';

// if (navigator.userAgent.indexOf(osVer)>0){
// }

var breakNum = 600;
var tabletNum = 1024;
// ////////////////////////////////////init
$(function () {
  setScroll();
  setHeader();
  // killClick()
  if (!$('#wrapper').hasClass('home')) {}
  // ///////////
  if (_ua.Tablet || _ua.Mobile) {} else {}
  // ///////////
  if (!_ua.Mobile) {}
});

$(window).on('load', function () {
  heightLineGroup();
  svg4everybody();
  setLoaded();
  judgeWinSize();
  setTab();
  setWay();
  setSubNav();
  setDrag();
  setMainMenu();
  setMenuAcc();
  setScrollTop();
  // setScrollTop()
  // setTextile()
  if ($('#wrapper').hasClass('home')) {} else {}
  if (!_ua.Mobile) {
  } else {}
});

// ///////メニューパネルアコーディオン
function setMenuAcc () {
  $('#menuPanel .accBtn').on('click', function () {
    $(this).toggleClass('active');
    $(this).parent().find('.child').slideToggle('fast');
  });
}

// ///////ヘッダーサブナビ制御
function setSubNav () {
  $('header .hasChild').on('mouseenter', function () {
    $(this).find('.child').stop().slideDown('fast');
    if (!$(this).hasClass('active')) {
      $(this).addClass('active');
    }
  });
  $('header .hasChild').on('mouseleave', function () {
    $(this).find('.child').stop().hide();
    $(this).removeClass('active');
  });
}

// ///////TOPボタン
function setScrollTop () {
  var baseHeight = 10;
  var footH = $('footer').height();
  var timer = false;
  fixedToTop();

  $(window).scroll(function () {
    fixedToTop();
  });

  function fixedToTop () {
    var scrollHeight = $(document).height() - footH;
    if ($(this).scrollTop() <= baseHeight) {
      $('#toTop').removeClass('active');
    }else if ($(this).scrollTop() > baseHeight) {
      $('#toTop').addClass('active');
    }
    if ($(window).height() + $(this).scrollTop() >= scrollHeight) {
      $('#toTop').addClass('footPos');
    }else {
      $('#toTop').removeClass('footPos');
    }
  }
}

// //////スクロールをドラッグ可能に
function setDrag () {
  $('.draggable>.inner').mousedragscrollable();
}

// //////scrollHint
window.addEventListener('DOMContentLoaded', function () {
  new ScrollHint('.js-scrollable', {
    i18n: {
      scrollable: 'スクロールできます'
    }
  });
  new ScrollHint('.js-scrollable-mark', {
    remainingTime: 3000,
    i18n: {
      scrollable: 'スクロールできます'
    }
  });
});

// シングルページにfancyBox
function setPostFancy () {
  $('.blocks-gallery-item a').fancybox({
  });
}

// /////郵便番号検索
function setPostal () {
  $('#zip').jpostal({
    postcode: [
      '#zip'
    ],
    address: {
      '#pref': '%3',
      '#address1': '%4%5'
    }
  });
  $('#zip_02').jpostal({
    postcode: [
      '#zip_02'
    ],
    address: {
      '#pref_02': '%3',
      '#address1_02': '%4%5'
    }
  });
}

// //////////////////////////フォーム制御
function setForm () {
  // URLのアンカー（#以降の部分）を取得
  var urlHash = location.hash;

  // URLにアンカーが存在する場合
  if (urlHash) {
    if (urlHash == '#reserve') {
      $('select[name=subject-type]').val('事前導入相談会について');
    }else if (urlHash == '#order') {
      $('select[name=subject-type]').val('有料お申し込みについて');
    }
  }

  // $('.copyCheck input').on('click', function () {
  //   if ($(this).prop('checked')) {
  //     $(this).parents('.inner').find('.orderAcc').hide()
  //     $('.copyCheckConf').addClass('show')
  //     $('.copyCheckCont').removeClass('show')
  //   }else {
  //     $(this).parents('.inner').find('.orderAcc').slideDown('fast')
  //     $('.copyCheckConf').removeClass('show')
  //     $('.copyCheckCont').addClass('show')
  //   }
  // })

  jQuery('.wpcf7-tel').attr('pattern', '\\d*');
  jQuery('.wpcf7-tel').attr('onkeyup', 'if(event.keyCode==9||event.keyCode==16) return; this.value=this.value.replace(/[^0-9]+/i,"")');

  // 郵便番号、電話番号のハイフン削除
  // function insertStr (input) {
  //   return input.replace('-', '')
  // }
  //
  // $('.wpcf7-tel').on('keyup', function (e) {
  //   var input = $(this).val()
  //
  //   // 削除キーではハイフン追加処理が働かないように制御（8がBackspace、46がDelete)
  //   var key = event.keyCode || event.charCode
  //   if (key == 8 || key == 46) {
  //     return false
  //   }
  //
  //   $(this).val(insertStr(input))
  // })
  //
  // $('.wpcf7-tel').on('blur', function (e) {
  //   var input = $(this).val()
  //
  //   $(this).val(insertStr(input))
  // })
  //
  $('input[name="acceptance-form"]').change(function () {
    var prop = $(this).prop('checked');
    if (prop) {
      $('#confirmBtn').removeClass('def');
    } else {
      $('#confirmBtn').addClass('def');
    }
  });

  $('#confirmBtn').on('click', function () {
    $('.wpcf7c-btn-confirm').click();
  });
  $('#backBtn').on('click', function () {
    $('.wpcf7c-btn-back').click();
  });
  $('#submitBtn').on('click', function () {
    $('.wpcf7-submit').click();
  });

  $('#press textarea').keypress(function () {
    $('.submitCol .sep').addClass('disp');
  });

  // /////エラーのとき
  document.addEventListener('wpcf7invalid', function (event) {
    setTimeout(function () {
      var position = $('.wpcf7-not-valid-tip:first').offset().top - 300;
      $('html,body').animate({
        scrollTop: position
      }, {
        queue: false
      });
    }, 100);
  }, false);
  // /////成功のとき
  document.addEventListener('wpcf7mailsent', function (event) {
    $('html,body').animate({
      scrollTop: 0
    }, {
      queue: false
    });
  }, false);
}
function hushCtl () {
  $('.contactHush').on('click', function () {
    $('select[name=subject-type]').val('有料お申し込みについて');
    $('body, html').animate({ scrollTop: 0 }, 500);
    return false;
  });
}

// ///////////////////////////フォーム確認画面
function setConfirm () {
  var tx = $('[name=company-name]').val();
  $('#companyTx').text(tx);
  var tx = $('[name=company-name-bill]').val();
  $('#companyTx_02').text(tx);

  var tx = $('[name=company-name-kana]').val();
  $('#companyTxKana').text(tx);
  var tx = $('[name=company-name-bill-kana]').val();
  $('#companyTxKana_02').text(tx);

  var tx = $('[name=name-sei]').val() + ' ' + $('[name=name-mei]').val();
  $('#nameTx').text(tx);
  var tx = $('[name=name-sei-bill]').val() + ' ' + $('[name=name-mei-bill]').val();
  $('#nameTx_02').text(tx);

  var tx = $('[name=name-sei-kana]').val() + ' ' + $('[name=name-mei-kana]').val();
  $('#nameTxKana').text(tx);
  var tx = $('[name=name-sei-bill-kana]').val() + ' ' + $('[name=name-mei-bill-kana]').val();
  $('#nameTxKana_02').text(tx);

  var tx = $('[name=mytel]').val();
  $('#telTx').text(tx);
  var tx = $('[name=mytel-bill]').val();
  $('#telTx_02').text(tx);

  var tx = $('[name=mymail]').val();
  $('#mailTx').text(tx);
  var tx = $('[name=mymail-bill]').val();
  $('#mailTx_02').text(tx);

  var tx = $('[name=subject-type]').val();
  $('#typeTx').text(tx);

  var tx = $('[name=content]').val();
  $('#contentTx').text(tx);

  var tx = '〒' + $('[name=zip]').val() + '<br>' + $('[name=pref]').val() + $('[name=address1]').val() + $('[name=address2]').val() + $('[name=address3]').val();
  $('#addressTx').html(tx);
  var tx = '〒' + $('[name=zip-bill]').val() + '<br>' + $('[name=pref-bill]').val() + $('[name=address1-bill]').val() + $('[name=address2-bill]').val() + $('[name=address3-bill]').val();
  $('#addressTx_02').html(tx);

  var tx = $('[name=group]').val();
  $('#groupTx').text(tx);
  var tx = $('[name=group-bill]').val();
  $('#groupTx_02').text(tx);

  var tx = $('[name=grade]').val();
  $('#gradeTx').text(tx);
  var tx = $('[name=grade-bill]').val();
  $('#gradeTx_02').text(tx);

  var tx = $('[name=ques2]').val();
  $('#quesTx2').text(tx);

  var tx = $('[name=date]').val();
  $('#dateTx').text(tx);

  var ques1Val = '未入力';
  $('input[name=ques1]:checked').each(function () {
    ques1Val = $(this).val();
  });
  $('#quesTx').text(ques1Val);

  var planVal = '未入力';
  $('input[name=plan]:checked').each(function () {
    planVal = $(this).val();
  });
  $('#planTx').text(planVal);

  var optionVal = 'なし';
  optionVal = $('.option').find('input:checked').map(function () {
    // $(this)でjQueryオブジェクトが取得できる。val()で値をvalue値を取得。
    return $(this).val();
  }).get();
  if (optionVal.length) {
    $('#optionTx').text(optionVal);
  }else {
    optionVal = 'なし';
    $('#optionTx').text(optionVal);
  }

  if ($('.copyBill input').prop('checked') == true) {
    $('.copyCheckConf').show();
    $('.copyCheckCont').hide();
  }else {
    $('.copyCheckConf').hide();
    $('.copyCheckCont').show();
  }
}

// //////////////////////////datePicker
function setDatePick () {
  $('.setDatePicker input').datepicker({
    minDate: 0
  });
}

// //////////////////////////メインメニュー
var current_scrollY;
function setMainMenu () {
  $('#burgerMenu').on('click', function () {
    if (!$(this).hasClass('active')) {
      openFnc();
    }else {
      closeFnc();
    }
  });

  $('#clickBlocker').on('click', function () {
    closeFnc();
  });

  var winW = $(window).width();
  var timer = false;
  var currentWidth = window.innerWidth;
  window.addEventListener('resize', function () {
    winW = $(window).width();
    if (currentWidth == window.innerWidth) {
      return;
    }
    currentWidth = window.innerWidth;
    if (timer !== false) {
      clearTimeout(timer);
    }
    timer = setTimeout(function () {
      if (winW > tabletNum) {
        closeFnc();
      }
    }, 200);
  });
}

function openFnc () {
  if ($('#wrapper').hasClass('fixedHeader')) {
    $('#wrapper').addClass('newsFlag');
  }else {
    $('#wrapper').removeClass('newsFlag');
  }
  current_scrollY = $(window).scrollTop();
  $('body').addClass('breakH');
  $('#burgerMenu').addClass('active');
  $('#wrapper').addClass('menuOpen');
  $('#outerMenu').css('top', -(current_scrollY));
  setTimeout(function () {
    $('html, body').prop({
      scrollTop: 0
    });
  }, 100);
}

function closeFnc () {
  $('body').removeClass('breakH');
  $('#wrapper').addClass('breakLuxy');
  $('#burgerMenu').removeClass('active');
  $('#outerMenu').css('top', '');
  $('#wrapper').removeClass('menuOpen');
  $('html, body').prop({
    scrollTop: current_scrollY
  });
  setTimeout(function () {
    $('#wrapper').removeClass('breakLuxy');
  }, 800);
}

// /////////////////////////////タブナビ制御
function setTab () {
  $('.accNav a').on('click', function () {
    if (!$(this).parent().hasClass('active')) {
      $(this).parents('.accNav').find('li').removeClass('active');
      var target = '#' + $(this).attr('class');
      $(this).parents('.accNav').next().find('.accSec').removeClass('active');
      $(this).parents('.accNav').next().find('.accSec').hide();
      $(target).fadeIn('fast');
      $(this).parent().addClass('active');
    }
  });
}

// /////////////////////////////無限スライダー
function setInfinite () {
  $('.infiniteslide.style_01').infiniteslide({
    speed: 50
  });
  $('.infiniteslide.style_02').infiniteslide({
    speed: 60
  });
}

// ////////////////////////////スライダー
function setCarousel01 () {
  var target = '.carouselStyle_01';
  var speed = 9000;
  $(target).each(function () {
    var owl = $(this).find('.screen');
    var baseCount = $(this).find('.screen>.carouselItem').length + 1;
    if (baseCount > 2) {
      // owl.addClass('owlCarousel')
      owl.owlCarousel({
        loop: true,
        // margin: 30,
        // slideSpeed: 3000,
        // paginationSpeed: 1000,
        // items: 3,
        smartSpeed: 1000,
        dots: false,
        nav: false,
        items: 2.5,
        // animateOut: 'fadeOut',
        URLhashListener: false,
        // stagePadding: 150,
        autoplay: true,
        autoplaySpeed: speed,
        mouseDrag: false,
        touchDrag: false,
      // slideBy: 1,
      // startPosition: 'URLHash'
      // slideBy:5,
      });
      owl.trigger('play.owl.autoplay', [500]);
      $(function () {
        setTimeout(function () {
          owl.trigger('play.owl.autoplay', [speed]);
        }, 1000);
      });
    } else {
      owl.removeClass('owl-carousel');
    }
    owl.on('changed.owl.carousel', function (e) {
      // owl.trigger('stop.owl.autoplay')
      // owl.trigger('play.owl.autoplay')
    });
  });
}

function setCarousel02 () {
  var target = '.carouselStyle_02';
  var speed = 9000;
  $(target).each(function () {
    var owl = $(this).find('.screen');
    var baseCount = $(this).find('.screen>.carouselItem').length + 1;
    if (baseCount > 2) {
      // owl.addClass('owlCarousel')
      owl.owlCarousel({
        loop: true,
        autoWidth: true,
        center: true,
        // margin: 30,
        // slideSpeed: 3000,
        // paginationSpeed: 1000,
        // items: 3,
        // slideSpeed: 300,
        // paginationSpeed: 100,
        slideTransition: 'linear',
        smartSpeed: speed,
        dots: false,
        nav: false,
        // animateOut: 'fadeOut',
        // autoplayTimeout: 100,
        autoplay: true,
        autoplaySpeed: speed,
        mouseDrag: false,
        touchDrag: false,
        items: 1,
        URLhashListener: false
      });
      owl.trigger('play.owl.autoplay', [500]);
      $(function () {
        setTimeout(function () {
          owl.trigger('play.owl.autoplay', [speed]);
        }, 1000);
      });
    // owl.trigger('play.owl.autoplay')
    } else {
      owl.removeClass('owl-carousel');
    }
    owl.on('changed.owl.carousel', function (e) {
      // owl.trigger('stop.owl.autoplay')
      // owl.trigger('play.owl.autoplay')
    });
  });
}

function setCarousel03 () {
  var target = '.carouselStyle_03';
  $(target).each(function () {
    var owl = $(this).find('.screen');
    var baseCount = $(this).find('.screen>.carouselItem').length + 1;
    if (baseCount > 2) {
      // owl.addClass('owlCarousel')
      owl.owlCarousel({
        loop: false,
        // autoWidth: true,
        // margin: 30,
        // slideSpeed: 3000,
        // paginationSpeed: 1000,
        // items: 3,
        // smartSpeed: 1000,
        dots: false,
        nav: false,
        // animateOut: 'fadeOut',
        mouseDrag: true,
        touchDrag: true,
        URLhashListener: false,
        autoplay: false,
        // slideBy: 1,
        responsive: {
          0: {
            items: 2,
          // margin: 15,
          // items: 1,
          // stagePadding: 35
          },
          769: {
            autoplay: false,
            // margin: 52,
            items: 4
          // slideBy: 1
          // stagePadding: 120
          }
        }
      // startPosition: 'URLHash'
      // slideBy:5,
      });
    } else {
      owl.removeClass('owl-carousel');
    }
    owl.on('changed.owl.carousel', function (e) {
      // owl.trigger('stop.owl.autoplay')
      // owl.trigger('play.owl.autoplay')
    });
  });
}

function setCarousel04 () {
  var target = '.carouselStyle_04';
  $(target).each(function () {
    var owl = $(this).find('.screen');
    var baseCount = $(this).find('.screen>.carouselItem').length + 1;
    if (baseCount > 2) {
      // owl.addClass('owlCarousel')
      owl.owlCarousel({
        loop: false,
        // autoWidth: true,
        // margin: 30,
        // slideSpeed: 3000,
        // paginationSpeed: 1000,
        items: 1,
        // smartSpeed: 1000,
        dots: true,
        nav: false,
        // animateOut: 'fadeOut',
        mouseDrag: true,
        touchDrag: true,
        URLhashListener: false,
      // autoplay: true,
      // autoplayTimeout: 5000,
      // autoplayHoverPause: true,
      // slideBy: 1,
      // startPosition: 'URLHash'
      // slideBy:5,
      });
    } else {
      owl.removeClass('owl-carousel');
    }
    owl.on('changed.owl.carousel', function (e) {
      // owl.trigger('stop.owl.autoplay')
      // owl.trigger('play.owl.autoplay')
    });
  });
}
// //////////////////////////メインメニュー
var current_scrollY;
function setMainMenu () {
  $('#burgerMenu').on('click', function () {
    if (!$(this).hasClass('active')) {
      openFnc();
    }else {
      closeFnc();
    }
  });

  $('#clickBlocker').on('click', function () {
    closeFnc();
  });

  var winW = $(window).width();
  var timer = false;
  var currentWidth = window.innerWidth;
  window.addEventListener('resize', function () {
    winW = $(window).width();
    if (currentWidth == window.innerWidth) {
      return;
    }
    currentWidth = window.innerWidth;
    if (timer !== false) {
      clearTimeout(timer);
    }
    timer = setTimeout(function () {
      if (winW > tabletNum) {
        closeFnc();
      }
    }, 200);
  });
}

function openFnc () {
  current_scrollY = $(window).scrollTop();
  $('.baseContent.show').addClass('stay');
  $('#burgerMenu').addClass('active');
  $('#wrapper').addClass('menuOpen');
  $('#outerMenu').css('top', -(current_scrollY));
  setTimeout(function () {
    $('html, body').prop({
      scrollTop: 0
    });
  }, 100);
}

function closeFnc () {
  $('.baseContent').removeClass('stay');
  $('#burgerMenu').removeClass('active');
  $('#outerMenu').css('top', '');
  $('#wrapper').removeClass('menuOpen');
  $('html, body').prop({
    scrollTop: current_scrollY
  });
}

// ///////ヘッダー制御
function setHeader () {
  var timer = false;
  $(window).on('resize', function () {
    if (timer !== false) {
      clearTimeout(timer);
    }
    timer = setTimeout(function () {
      $('header').removeClass('fixedHeader');
    }, 10);
  });

  fixedHeader();

  $(window).scroll(function () {
    fixedHeader();
  });

  function fixedHeader () {
    if ($('#wrapper').hasClass('home')) {
      h = $('header').height();
    }else {
      h = $('header').height();
    }
    baseHeight = h;
    if ($(this).scrollTop() <= baseHeight) {
      $('#wrapper').removeClass('fixedHeader');
    }else if ($(this).scrollTop() > baseHeight) {
      $('#wrapper').addClass('fixedHeader');
    }
  }
}

// ////////////ウィンドウサイズを判別
function judgeWinSize () {
  var winW = $(window).width();
  if (winW > breakNum) {
    $('#wrapper').addClass('setPc');
  } else {
    $('#wrapper').addClass('setSp');
  }

  var timer = false;
  var currentWidth = window.innerWidth;
  window.addEventListener('resize', function () {
    if (currentWidth == window.innerWidth) {
      return;
    }
    currentWidth = window.innerWidth;
    if (timer !== false) {
      clearTimeout(timer);
    }
    timer = setTimeout(function () {
      winW = $(window).width();
      if (winW > breakNum) {
        $('#wrapper').addClass('setPc');
        $('#wrapper').removeClass('setSp');
      } else {
        $('#wrapper').addClass('setSp');
        $('#wrapper').removeClass('setPc');
      }
    }, 200);
  });
}

// //////////////////////////////ロード完了
function setLoaded () {
  $('#loading').addClass('loaded');
  $('#wrapper').addClass('loaded');
  $('body,html').animate({
    scrollTop: 0
  }, 0, 'swing');
}

// ///////waypoint
function setWay () {
  $('.way,.alphaWay,.scaleWay,.setAnimation,#bgTx>div,.nullWay').waypoint(function (direction) {
    var activePoint = $(this.element);
    if (direction === 'down') { // scroll down
      activePoint.addClass('active');
    }
  //    else{ //scroll up
  //        activePoint.removeClass('active')
  //    }
  }, {
    offset: '70%'
  });

  $('.shuffle').waypoint(function (direction) {
    var activePoint = $(this.element);
    if (direction === 'down') { // scroll down
      activePoint.addClass('active');
      // var container = $(this.element)
      activePoint.shuffleLetters();
    }
  //    else{ //scroll up
  //        activePoint.removeClass('active')
  //    }
  }, {
    offset: '70%'
  });

  $('.scaleway,.nullWay,.ttlStyle_05,.fade_01,.fade_02').waypoint(function (direction) {
    var activePoint = $(this.element);
    if (direction === 'down') { // scroll down
      activePoint.addClass('active');
    }
  //    else{ //scroll up
  //        activePoint.removeClass('active')
  //    }
  }, {
    offset: '70%'
  });
}

// /////////////////////////////スムーススクロール
function setScroll () {
  var headerHight = $('header').height() + 40;

  $('a[href^="#"]').click(function (e) {
    var href = $(this).attr('href');
    var target = $(href == '#' || href == '' ? 'html' : href);
    var position = target.offset().top - headerHight;

    if ($(this).hasClass('unqNav')) {
      closeFnc();
    }
    $.when(
      $('html, body').animate({
        scrollTop: position
      }, 400, 'swing'),
      e.preventDefault()
    ).done(function () {
      var diff = target.offset().top - headerHight;
      if (diff === position) {
      } else {
        $('html, body').animate({
          scrollTop: diff
        }, 10, 'swing');
      }
    });
  });
}

function startScroll () {
  // var headerHight = 0
  var headerHight = $('header').height() + 40;
  var href = $(location).attr('hash');
  var target = $(href == '#' || href == '' ? 'html' : href);
  var position = target.offset().top - headerHight;

  $.when(
    $('html, body').animate({
      scrollTop: position
    }, 400, 'swing')
  ).done(function () {
    var diff = target.offset().top - headerHight;
    if (diff === position) {
    } else {
      $('html, body').animate({
        scrollTop: diff
      }, 10, 'swing');
    }
  });
}

// ////////////////////////////////////ランドスケープ判定
var isLandscape = function () {
  if (window.innerHeight > window.innerWidth) {
    jQuery('body').addClass('portrait');
    jQuery('body').removeClass('landscape');
  } else {
    jQuery('body').addClass('landscape');
    jQuery('body').removeClass('portrait');
  }
};

if (_ua.Mobile) {
  jQuery(window).resize(function () {
    isLandscape();
  });
  isLandscape();
}

// //////////////////////////////高さ揃え
function heightLineGroup () {
  // setAutoHeight('#photoDiary .articleStyle_02 .inner')
  var winW = $(window).width();
  if (winW > breakNum) {
    setAutoHeight('.setH_01 .headTtl');
    setAutoHeight('.setH_01 h2');
  // setAutoHeight('#photoDiary .articleStyle_02 .inner')
  // setAutoHeight(".setH_01 .summary",3)
  } else {
    // setAutoHeight("#setH_08 h2",2)
  }

  startResize();
}

function setAutoHeight (target, count) {
  $(target).tile(count);
}

function startResize () {
  var timer = false;
  var currentWidth = window.innerWidth;
  window.addEventListener('resize', function () {
    if (currentWidth == window.innerWidth) {
      return;
    }
    currentWidth = window.innerWidth;
    if (timer !== false) {
      clearTimeout(timer);
    }
    timer = setTimeout(function () {
      heightLineGroup();
    }, 200);
  });
}
